import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import {
  reducerRegistry,
  sagaRegistry,
  OAuthSaga,
  OAuthReducer,
  openAuthenticationWindowAction,
} from 'coral-utility';
import Landing from './landing';

reducerRegistry.register('oauth', OAuthReducer);
sagaRegistry.register('oauth', OAuthSaga);

const mapStateToProps = (state: object) => ({
  ...state,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ openAuthenticationWindowAction }, dispatch);

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(Landing));
